import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import {
  FeedIntakeUnit,
  WaterIntakeUnit,
} from 'src/app/reference-value-sheet/models/reference-value-sheet.model';
import { UnitOfMeasureSettings } from 'src/app/settings/models/setting.model';

import * as withinCyclePerformanceActions from '../../within-cycle-performance/store/actions/within-cycle-performance.actions';

@Injectable({
  providedIn: 'root',
})
export class ObservationsGuard {
  private store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.store.dispatch(
      withinCyclePerformanceActions.loadObservationsForCycleRequest({
        cycleId: Number(route.paramMap.get('cycleId')),
        unitOfMeasureSettings: {
          feedIntakeUnit: FeedIntakeUnit.CumulativeKilogram,
          waterIntakeUnit: WaterIntakeUnit.CumulativeLiter,
        } as UnitOfMeasureSettings,
      }),
    );
    return of(true);
  }
}
